<template>
	<el-dialog :visible.sync="visible" title="删除提示" width="426px">
		<div class="flex">
			<img src="@/assets/public/warning-org.png" style="width: 16px; height: 16px; margin-top: 2px" alt="" />
			<div class="yx-pingfang-Medium fz-14 yx-color-text-primary ml-6">
				<p>标签删除后，商品上的该标签会被移除。</p>
				<p>删除后的标签将无法恢复！</p>
			</div>
		</div>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="del">删 除</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { delTags } from '@/api/shopManage';
export default {
	data() {
		return {
			visible: false,
			id: '',
		};
	},
	props: {
		type: {
			type: [Number, String],
			default: '0',
		},
	},
	methods: {
		show(id) {
			this.id = id;
			this.visible = true;
		},
		async del() {
			const { id: tags_id } = this;
			const { code } = await delTags({ tags_id, type: this.type }); //0商品标签， 1达人标签
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.$emit('refreshList');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
		},
	},
};
</script>
